import { useLingui } from '@lingui/react';
import styled from 'styled-components';
import { WrapperItem } from '~/components/ui/wrapper-item';
import Modal from '~/components/ui/modal';
import Button from '~/components/ui/button';

import { RulesClassementContent } from '~/components/game/rules-classement-content';

interface IProps {
  open: boolean;
  onClose: () => void;
}
type TProps = IProps;

export default function RulesClassementDialog({ open, onClose }: TProps) {
  const { i18n } = useLingui();

  return (
    <Modal
      heightPortrait="90%"
      heightLandscape="70%"
      widthPortrait="95%"
      widthLandscape="auto"
      onClose={onClose}
      open={open}
    >
      <Container>
        <WrapperItem
          setMaxHeight
          widthPortrait="100%"
          widthLandscape="100%"
          title={`${i18n._('common.rules')}`}
        >
          <ContentWrapper>
            <RulesClassementContent />

            <SDivBtn className={open ? 'open' : 'closed'}>
              {open && (
                <Button
                  type={'button'}
                  disabled={!open}
                  color="primary"
                  onClick={onClose}
                  margin="20px 0 0 0"
                >
                  {i18n._('common.ok')}
                </Button>
              )}
            </SDivBtn>
          </ContentWrapper>
        </WrapperItem>
      </Container>
    </Modal>
  );
}

const ContentWrapper = styled.div`
  flex-grow: 1;
  overflow: auto;
`;

const SDivBtn = styled.div`
  align-items: center;
  display: flex;
  justify-content: center;
  margin-top: auto;
`;

const Container = styled.div`
  padding: 5px;
  height: 100%;
  width: 100%;
  display: flex;
  justify-content: center;
`;
